import { HEADER } from '../../utils/constants';

const initTransparentHeader = () => {
  const header = document.querySelector('[data-header-transparent]');
  if (!header) return;

  const desktopNavigation = document.querySelector('[data-navigation-desktop]');

  // Sets the header background based on scroll position
  const setHeaderBg = (scrolled) => {
    if (scrolled) {
      header.dataset.headerScrolled = true;
    } else {
      header.dataset.headerScrolled = false;
    }
  };

  // Setting header background on scroll
  window.addEventListener('scroll', () => {
    if (!desktopNavigation.hasAttribute('open')) {
      setHeaderBg(window.scrollY > HEADER.SCROLL_THRESHOLD);
    }
  });

  // Initial header background state
  setHeaderBg(window.scrollY > HEADER.SCROLL_THRESHOLD);
};

export default initTransparentHeader;
